"use strict";
/**
 * @module "ethpm/manifests/v3"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.v3 = exports.Writer = exports.Reader = void 0;
const t = __importStar(require("io-ts"));
const url_1 = require("url");
const json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
const types_1 = require("../../types");
const config = __importStar(require("../../config"));
const deepEqual = require('deep-equal');
const VERSION = 'ethpm/3';
var Fields;
(function (Fields) {
    function readContractTypes(contractTypes) {
        return Object.assign({}, ...Object.entries(contractTypes)
            .map(([alias, contractType]) => ({
            [alias]: readContractType(contractType, alias),
        })));
    }
    Fields.readContractTypes = readContractTypes;
    function readDeployments(deployments, types) {
        return new Map(Object.entries(deployments)
            .map(([chainURI, deployment]) => [
            new url_1.URL(chainURI),
            readDeployment(deployment, types),
        ]));
    }
    Fields.readDeployments = readDeployments;
    function readContractType(contractType, alias) {
        return {
            contractName: contractType.contractName || alias,
            deploymentBytecode: types_1.lift(readBytecode)(contractType.deploymentBytecode),
            runtimeBytecode: types_1.lift(readBytecode)(contractType.runtimeBytecode),
            abi: contractType.abi,
            userdoc: contractType.userdoc,
            devdoc: contractType.devdoc,
            sourceId: contractType.sourceId,
        };
    }
    Fields.readContractType = readContractType;
    function readCompilers(compilers) {
        return compilers;
    }
    Fields.readCompilers = readCompilers;
    function readBytecode(bytecode, parent) {
        // bytecode of some kind is required
        if (!bytecode) {
            return undefined;
        }
        const bytestring = (bytecode.bytecode)
            ? bytecode.bytecode
            : parent && parent.bytecode;
        // needs bytestring itself or from parent
        if (!bytestring) {
            return undefined;
        }
        return {
            bytecode: bytestring,
            linkReferences: [...((bytecode.linkReferences)
                    ? bytecode.linkReferences
                    : (parent && parent.linkReferences)
                        ? parent.linkReferences
                        : [])],
            linkDependencies: readLinkDependencies(bytecode.linkDependencies),
        };
    }
    Fields.readBytecode = readBytecode;
    function readLinkDependencies(linkDependencies) {
        return [
            ...(linkDependencies || [])
                .map(({ offsets, value, type }) => ({
                offsets,
                value: (type === 'literal')
                    ? {
                        value: value,
                        type: type,
                    }
                    : {
                        value: value,
                        type: type,
                    },
            })),
        ];
    }
    Fields.readLinkDependencies = readLinkDependencies;
    function readCompiler(compiler) {
        return { name: compiler.name, version: compiler.version,
            settings: compiler.settings || {},
        };
    }
    Fields.readCompiler = readCompiler;
    function readDeployment(deployment, types) {
        return Object.assign({}, ...Object.entries(deployment).map(([name, instance]) => ({
            [name]: readInstance(instance, types),
        })));
    }
    Fields.readDeployment = readDeployment;
    function readInstance(instance, types) {
        return {
            contractType: instance.contractType,
            address: instance.address,
            transaction: instance.transaction,
            block: instance.block,
            runtimeBytecode: readBytecode(instance.runtimeBytecode, (types[instance.contractType] || {}).runtimeBytecode),
        };
    }
    Fields.readInstance = readInstance;
    function writeContractTypes(contractTypes) {
        return Object.assign({}, ...Object.entries(contractTypes)
            .map(([alias, contractType]) => ({
            [alias]: writeContractType(contractType, alias),
        })));
    }
    Fields.writeContractTypes = writeContractTypes;
    function writeDeployments(deployments, types) {
        return Object.assign({}, ...Array.from(deployments.entries())
            .map(([chainURI, deployment]) => ({
            [chainURI.href]: writeDeployment(deployment, types),
        })));
    }
    Fields.writeDeployments = writeDeployments;
    function writeContractType(contractType, alias) {
        return Object.assign({ deploymentBytecode: types_1.lift(writeBytecode)(contractType.deploymentBytecode), runtimeBytecode: types_1.lift(writeBytecode)(contractType.runtimeBytecode), abi: contractType.abi, devdoc: contractType.devdoc, userdoc: contractType.userdoc, sourceId: contractType.sourceId }, ((contractType.contractName != alias)
            ? { contractName: contractType.contractName }
            : {}));
    }
    Fields.writeContractType = writeContractType;
    function writeCompilers(compilers) {
        return compilers;
    }
    Fields.writeCompilers = writeCompilers;
    function writeBytecode(bytecode, parent) {
        return Object.assign(Object.assign(Object.assign({}, ((!parent || bytecode.bytecode != parent.bytecode)
            ? { bytecode: bytecode.bytecode }
            : {})), ((bytecode.linkReferences.length > 0 && (!parent || !deepEqual(bytecode.linkReferences, parent.linkReferences)))
            ? { linkReferences: [...bytecode.linkReferences] }
            : {})), ((bytecode.linkDependencies.length > 0 && (!parent
            || !deepEqual(bytecode.linkDependencies, parent.linkDependencies)))
            ? { linkDependencies: writeLinkDependencies(bytecode.linkDependencies) }
            : {}));
    }
    Fields.writeBytecode = writeBytecode;
    function writeLinkDependencies(linkDependencies) {
        return [
            ...(linkDependencies || [])
                .map(({ offsets, value }) => (Object.assign(Object.assign({ offsets }, ('type' in value ? { type: value.type } : {})), ('value' in value ? { value: value.value } : {})))),
        ];
    }
    Fields.writeLinkDependencies = writeLinkDependencies;
    function writeCompiler(compiler) {
        return {
            name: compiler.name,
            version: compiler.version,
            settings: compiler.settings,
        };
    }
    Fields.writeCompiler = writeCompiler;
    function writeDeployment(deployment, types) {
        return Object.assign({}, ...Object.entries(deployment).map(([name, instance]) => ({
            [name]: writeInstance(instance, types),
        })));
    }
    Fields.writeDeployment = writeDeployment;
    function writeInstance(instance, types) {
        // type ignore b/c undefined case is handled on 295
        // @ts-ignore
        return Object.assign(Object.assign(Object.assign({ contractType: instance.contractType, address: instance.address }, ((instance.runtimeBytecode)
            ? {
                runtimeBytecode: writeBytecode(instance.runtimeBytecode, (types[instance.contractType] || {}).runtimeBytecode),
            }
            : {})), (instance.transaction ? { transaction: instance.transaction } : {})), (instance.block ? { block: instance.block } : {}));
    }
    Fields.writeInstance = writeInstance;
})(Fields || (Fields = {}));
class Reader {
    constructor(manifest) {
        this.manifest = manifest;
    }
    read() {
        return {
            packageName: this.packageName,
            version: this.version,
            manifest: this.manifestVersion,
            meta: this.meta,
            sources: this.sources,
            contractTypes: this.contractTypes,
            compilers: this.compilers,
            deployments: this.deployments,
            buildDependencies: this.buildDependencies,
        };
    }
    get packageName() {
        return this.manifest.name;
    }
    get version() {
        return this.manifest.version;
    }
    get manifestVersion() {
        if (typeof this.manifest.manifest === 'undefined') {
            return VERSION;
        }
        else if (this.manifest.manifest !== VERSION) {
            throw new Error(`Unsupported manifest version ${this.manifest.manifest}`);
        }
        else {
            return this.manifest.manifest;
        }
    }
    get meta() {
        const metadata = this.manifest.meta || {};
        return {
            authors: metadata.authors,
            license: metadata.license,
            description: metadata.description,
            keywords: metadata.keywords,
            links: Object.entries(metadata.links || {}).map(([resource, uri]) => ({ resource, uri })),
        };
    }
    get sources() {
        const sources = this.manifest.sources || {};
        return Object.assign({}, ...Object.entries(sources)
            .map(([path, sourceObject]) => {
            const installPath = path.startsWith("./") ? path : `./${path}`;
            try {
                return {
                    [path]: {
                        installPath: installPath,
                        type: "solidity",
                        urls: [new url_1.URL(sourceObject['urls'][0])],
                    }
                };
            }
            catch (e) {
                return {
                    [path]: {
                        installPath: installPath,
                        type: "solidity",
                        content: sourceObject['content'],
                    }
                };
            }
        }));
    }
    get contractTypes() {
        return Fields.readContractTypes(this.manifest.contractTypes || {});
    }
    get compilers() {
        return Fields.readCompilers(this.manifest.compilers || []);
    }
    get deployments() {
        return Fields.readDeployments(this.manifest.deployments || {}, this.contractTypes);
    }
    get buildDependencies() {
        return Object.assign({}, ...Object.entries(this.manifest.buildDependencies || {})
            .map(([name, contentURI]) => ({
            [name]: new url_1.URL(contentURI),
        })));
    }
}
exports.Reader = Reader;
class Writer {
    constructor(package_) {
        this.package = package_;
    }
    get name() {
        return this.package.packageName;
    }
    get version() {
        return this.package.version;
    }
    get meta() {
        const metadata = this.package.meta;
        return Object.assign((metadata.authors && metadata.authors.length > 0)
            ? { authors: metadata.authors }
            : {}, (metadata.license)
            ? { license: metadata.license }
            : {}, (metadata.description)
            ? { description: metadata.description }
            : {}, (metadata.keywords && metadata.keywords.length > 0)
            ? { keywords: metadata.keywords }
            : {}, (metadata.links && metadata.links.length > 0)
            ? {
                links: Object.assign({}, ...metadata.links.map(({ resource, uri }) => ({ [resource]: uri }))),
            }
            : {});
    }
    get sources() {
        const { sources } = this.package;
        return Object.assign({}, ...Object.entries(sources)
            .map(([path, source]) => ((source instanceof url_1.URL)
            ? { [path]: source.href }
            : { [path]: source })));
    }
    get contractTypes() {
        return Fields.writeContractTypes(this.package.contractTypes);
    }
    get compilers() {
        return Fields.writeCompilers(this.package.compilers);
    }
    get deployments() {
        return Fields.writeDeployments(this.package.deployments, this.package.contractTypes);
    }
    get buildDependencies() {
        return Object.assign({}, ...Object.entries(this.package.buildDependencies)
            .map(([name, contentURI]) => ({
            [name]: contentURI.href,
        })));
    }
    write() {
        return Object.assign({
            manifest: VERSION,
            name: this.name,
            version: this.version,
        }, ...Object.entries({
            deployments: this.deployments,
            contractTypes: this.contractTypes,
            compilers: this.compilers,
            sources: this.sources,
            buildDependencies: this.buildDependencies,
            meta: this.meta,
        }).map(([field, obj]) => ((Object.keys(obj).length > 0)
            ? { [field]: obj }
            : {})));
    }
}
exports.Writer = Writer;
const v3 = {
    version: VERSION,
    readSync: (json) => new Reader(JSON.parse(json)).read(),
    read: (json) => __awaiter(void 0, void 0, void 0, function* () { return new Reader(JSON.parse(json)).read(); }),
    write: (pkg) => __awaiter(void 0, void 0, void 0, function* () { return json_stable_stringify_1.default(yield new Writer(pkg).write()); }),
};
exports.v3 = v3;
class Connector extends config.Connector {
    constructor() {
        super(...arguments);
        this.optionsType = t.interface({});
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            return v3;
        });
    }
}
exports.default = Connector;
